export default "__VITE_ASSET__ebdbfecc__"